import {Component, NgZone, ViewChild} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {UserService} from "../services/user.service";
import firebase from "firebase/compat/app";
import {TeacherService} from "../services/teacher.service";
import {Teacher} from "../interfaces/teacher";
import {DatePipe} from '@angular/common';
import {Event} from "../interfaces/event";
import {EventsFormComponent} from "../events-form/events-form.component";
import {EventsComponent} from "../events/events.component";

@Component({
  selector: 'app-events-details',
  templateUrl: './events-details.component.html',
  standalone: true,
  imports: [
    FormsModule,
    DatePipe,
    NgIf,
    RouterLink,
    EventsFormComponent,
  ],
  styleUrl: './events-details.component.css'
})
export class EventsDetailsComponent {
  constructor(private route: ActivatedRoute, public userService: UserService, private ngZone: NgZone, private router: Router, private teacherService: TeacherService) {
  }

  eventId!: string;
  event!: Event;
  isEditing = false;
  teacher: Teacher | null = null;
  eventExists = true;
  @ViewChild(EventsFormComponent) formComponent!: EventsFormComponent;

  async ngOnInit() {
    this.teacher = await this.teacherService.getTeacher();
    this.eventId = this.route.snapshot.paramMap.get("id")!;
    await this.loadEvent();
  }

  async loadEvent() {
    try {
      const docSnap = await firebase
        .firestore()
        .collection("event")
        .doc(this.eventId)
        .get();

      if (docSnap.exists) {
        this.event = {id: docSnap.id, ...docSnap.data()} as Event;
      } else {
        this.eventExists = false;
      }
    } catch (err) {
      this.eventExists = false;
    }
  }

  toggleEditing() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      // wait for the form
      setTimeout(() => {
        if (this.formComponent && this.event) {
          this.formComponent.initializeForm(this.event);
        }
      }, 0);
    }
  }

  onFormUpdated(updatedEvent: Event) {
    this.event = updatedEvent;
    this.isEditing = false;
  }

  isDeleting = false;

  deleteEvent() {
    if (!confirm("Are you sure you want to delete this event?")) return;
    this.isDeleting = true;

    return firebase.firestore()
      .collection('event')
      .doc(this.event.id)
      .set({isDeleted: true}, {merge: true})
      .then(() => {
        this.event.isDeleted = true;
        this.isDeleting = false;
      })
      .catch(err => {
        console.error(err);
        this.isDeleting = false;
      });
  }

  undeleteEvent() {
    if (!confirm("Are you sure you want to undelete this event?")) return;
    this.isDeleting = true;

    return firebase.firestore()
      .collection('event')
      .doc(this.event.id)
      .set({isDeleted: false}, {merge: true})
      .then(() => {
        this.event.isDeleted = false;
        this.isDeleting = false;
      })
      .catch(err => {
        console.error(err);
        this.isDeleting = false;
      });
  }

  formatPhone(value: string): string {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 10) return value;
    return `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
  }
}
